(() => {
  if (window.agroverdeCareersV8Loaded) {
    return;
  }

  window.agroverdeCareersV8Loaded = true;

  const rdEventName = "agroverde_trabalhe_conosco_interacao";
  const dataLayerEventName = "agroverde_careers_interaction";
  const sessionKey = "agroverde_careers_session_id";
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getSessionId() {
    try {
      const existing = window.sessionStorage.getItem(sessionKey);

      if (existing) {
        return existing;
      }

      const sessionId = `agv-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.sessionStorage.setItem(sessionKey, sessionId);
      return sessionId;
    } catch (error) {
      return `agv-${Date.now()}`;
    }
  }

  function clean(value, maxLength = 160) {
    return String(value || "").trim().replace(/\s+/g, " ").slice(0, maxLength);
  }

  function getPageContext() {
    const params = new URLSearchParams(window.location.search);
    const context = {
      component: "trabalhe_conosco",
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      referrer: document.referrer || "",
      session_id: getSessionId()
    };

    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((key) => {
      const value = params.get(key);

      if (value) {
        context[key] = value;
      }
    });

    return context;
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: dataLayerEventName,
      careers_interaction: payload.interaction,
      careers_location: payload.location || payload.location_filter || "",
      careers_job: payload.job_title || "",
      careers_component: payload.component,
      careers_page_path: payload.page_path,
      careers_session_id: payload.session_id
    });
  }

  function track(interaction, details = {}) {
    const payload = {
      ...getPageContext(),
      ...details,
      interaction
    };

    pushDataLayer(payload);

    if (window.rdtracker && typeof window.rdtracker.track === "function") {
      try {
        window.rdtracker.track(rdEventName, payload);
      } catch (error) {
        window.console && window.console.warn && window.console.warn("RD tracking failed", error);
      }
    }
  }

  function getField(form, name) {
    return form.querySelector(`[name="${name}"]`);
  }

  function getFieldValue(form, name) {
    const field = getField(form, name);
    return clean(field ? field.value : "");
  }

  function getFormContext(form) {
    return {
      location: getFieldValue(form, "location"),
      location_label: getFieldValue(form, "locationLabel"),
      job_title: getFieldValue(form, "jobTitle")
    };
  }

  function identify(form) {
    const email = getFieldValue(form, "email").toLowerCase();

    if (!emailPattern.test(email)) {
      return false;
    }

    if (window.rdtracker && typeof window.rdtracker.identify === "function") {
      const identity = { email };
      const name = getFieldValue(form, "name");
      const phone = getFieldValue(form, "phone");

      if (name) {
        identity.name = name;
      }

      if (phone) {
        identity.phone = phone;
        identity.personal_phone = phone;
      }

      try {
        window.rdtracker.identify(identity);
      } catch (error) {
        window.console && window.console.warn && window.console.warn("RD identify failed", error);
      }
    }

    return true;
  }

  function getEndpoint(form, section) {
    const action = clean(form.getAttribute("action"));

    if (action && action !== "#") {
      return action;
    }

    return clean(section.dataset.endpoint);
  }

  function getStatusElement(form) {
    let status = form.querySelector("[data-form-status]");

    if (!status) {
      status = document.createElement("p");
      status.setAttribute("data-form-status", "");
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      form.appendChild(status);
    }

    return status;
  }

  function getResumePayload(input) {
    const file = input.files && input.files[0];

    if (!file) {
      return { resume_selected: false };
    }

    const name = file.name || "";
    const extension = name.includes(".") ? name.slice(name.lastIndexOf(".") + 1).toLowerCase() : "";
    const sizeKb = Math.round(file.size / 1024);

    return {
      resume_selected: true,
      resume_extension: extension,
      resume_size_kb: sizeKb,
      resume_size_bucket: sizeKb <= 1024 ? "ate_1mb" : sizeKb <= 3072 ? "1mb_a_3mb" : "3mb_a_5mb"
    };
  }

  function bindFilters(section) {
    const cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
    const emptyState = section.querySelector("[data-empty-state]");
    const filters = Array.from(section.querySelectorAll("[data-location-filter]"));

    filters.forEach((filter) => {
      if (filter.dataset.rdTracked === "true") {
        return;
      }

      filter.dataset.rdTracked = "true";
      filter.addEventListener("click", () => {
        const location = filter.dataset.locationFilter || "all";
        let visibleCount = 0;

        filters.forEach((item) => {
          item.classList.toggle("is-active", item.dataset.locationFilter === location);
        });

        cards.forEach((card) => {
          const shouldShow = location === "all" || card.dataset.location === location;
          card.hidden = !shouldShow;

          if (shouldShow) {
            visibleCount += 1;
          }
        });

        if (emptyState) {
          emptyState.hidden = visibleCount > 0;
        }

        track("filter_click", {
          location_filter: location,
          visible_vacancies: visibleCount
        });
      });
    });
  }

  function bindRequirementDetails(section) {
    section.querySelectorAll("[data-vacancy-card] > details:not(.agv-careers__application)").forEach((details) => {
      if (details.dataset.rdTracked === "true") {
        return;
      }

      details.dataset.rdTracked = "true";
      details.addEventListener("toggle", () => {
        if (!details.open) {
          return;
        }

        const card = details.closest("[data-vacancy-card]");
        track("requirements_open", {
          location: card ? clean(card.dataset.location) : "",
          job_title: card ? clean(card.querySelector("h3")?.textContent) : ""
        });
      });
    });
  }

  function bindApplicationDetails(section) {
    section.querySelectorAll(".agv-careers__application").forEach((details) => {
      if (details.dataset.rdTracked === "true") {
        return;
      }

      details.dataset.rdTracked = "true";
      details.addEventListener("toggle", () => {
        const form = details.querySelector("form");
        const context = form ? getFormContext(form) : {};
        track(details.open ? "application_form_open" : "application_form_close", context);
      });
    });
  }

  function bindGoogleFormLinks(section) {
    section.querySelectorAll("[data-google-form-apply]").forEach((link) => {
      if (link.dataset.rdTracked === "true") {
        return;
      }

      link.dataset.rdTracked = "true";
      link.addEventListener("click", () => {
        track("google_form_open", {
          location: clean(link.dataset.location),
          location_label: clean(link.dataset.locationLabel),
          job_title: clean(link.dataset.jobTitle),
          destination_url: clean(link.href, 300)
        });
      });
    });
  }

  function bindForm(form, section) {
    if (form.dataset.rdTracked === "true") {
      return;
    }

    form.dataset.rdTracked = "true";
    let formStarted = false;

    form.addEventListener("focusin", () => {
      if (formStarted) {
        return;
      }

      formStarted = true;
      track("application_form_start", getFormContext(form));
    });

    form.querySelectorAll('input[name="name"], input[name="email"], input[name="phone"], textarea[name="message"]').forEach((field) => {
      field.addEventListener("change", () => {
        if (field.name === "email") {
          identify(form);
        }

        track("application_field_completed", {
          ...getFormContext(form),
          field_name: field.name,
          has_value: clean(field.value).length > 0
        });
      });
    });

    const consent = form.querySelector('input[type="checkbox"][required]');

    if (consent) {
      consent.addEventListener("change", () => {
        track(consent.checked ? "application_consent_checked" : "application_consent_unchecked", getFormContext(form));
      });
    }

    const resumeInput = form.querySelector('input[type="file"][name="resume"]');

    if (resumeInput) {
      resumeInput.addEventListener("change", () => {
        track("resume_selected", {
          ...getFormContext(form),
          ...getResumePayload(resumeInput)
        });
      });
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      identify(form);

      const endpoint = getEndpoint(form, section);
      const status = getStatusElement(form);
      const submitButton = form.querySelector('[type="submit"]');
      const context = getFormContext(form);

      track("application_submit_attempt", context);

      if (!endpoint) {
        status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        track("application_submit_blocked", { ...context, reason: "missing_endpoint" });
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
      }

      status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          body: new FormData(form)
        });
        const contentType = response.headers.get("content-type") || "";
        const result = contentType.includes("application/json") ? await response.json() : { ok: response.ok };

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        track("application_submit_success", context);
        form.reset();
        status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu curriculo.";
      } catch (error) {
        track("application_submit_error", {
          ...context,
          error_message: clean(error.message || "submit_error", 120)
        });
        status.textContent = error.message || "Nao foi possivel enviar sua candidatura agora.";
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  }

  function observeVacancies(section) {
    if (!("IntersectionObserver" in window)) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.4) {
          return;
        }

        const card = entry.target;
        observer.unobserve(card);
        track("vacancy_card_viewed", {
          location: clean(card.dataset.location),
          job_title: clean(card.querySelector("h3")?.textContent)
        });
      });
    }, { threshold: [0.4] });

    section.querySelectorAll("[data-vacancy-card]").forEach((card) => observer.observe(card));
  }

  function initCareers(section) {
    if (section.dataset.rdCareersReady === "true") {
      return;
    }

    section.dataset.rdCareersReady = "true";
    bindFilters(section);
    bindRequirementDetails(section);
    bindApplicationDetails(section);
    bindGoogleFormLinks(section);
    section.querySelectorAll("form").forEach((form) => bindForm(form, section));
    observeVacancies(section);
    track("page_view", {
      vacancy_count: section.querySelectorAll("[data-vacancy-card]").length
    });
  }

  function initAllCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach(initCareers);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllCareers());
  } else {
    initAllCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAllCareers(event.target));
})();
